import React, { useEffect, useState, useRef } from 'react';
import { Spinner } from 'react-bootstrap';
import useAuth from './useAuth';
import EmployeeHeader from '../components/EmployeeHeader';

// Import all profile components
import DoctorsProfile from './profilePages/DoctorsProfile';
import AdminsProfile from './profilePages/AdminsProfile';
import EmployeesProfile from './profilePages/EmployeesProfile';
import PoojarisProfile from './profilePages/PoojarisProfile';

const ProfilePage = () => {
     useAuth();
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const role = sessionStorage.getItem('user_role');
     const [employeeDetails, setEmployeeDetails] = useState(null);
     const [empLoading, setEmpLoading] = useState(true);

     const [currentEmployee, setCurrentEmployee] = useState({
          photo: 'https://randomuser.me/api/portraits/men/32.jpg',
          name: '',
          id: '',
          role: ''
     });

     const [showPopup, setShowPopup] = useState(false);
     const popupRef = useRef(null);
     const buttonRef = useRef(null);

     useEffect(() => {
          const userCode = sessionStorage.getItem('user_code');
          const userName = sessionStorage.getItem('user_name');
          const userRole = sessionStorage.getItem('user_role');
          setCurrentEmployee((prev) => ({
               ...prev,
               name: userName,
               id: userCode,
               role: userRole || 'User'
          }));
     }, []);

     useEffect(() => {
          const userCode = sessionStorage.getItem('user_code');
          if (!userCode) return;

          const fetchEmployeeDetails = async () => {
               try {
                    setEmpLoading(true);
                    const token = sessionStorage.getItem('token');
                    // Use the correct endpoint for doctor profile
                    const response = await fetch(
                         `${baseUrl}/user_profile_new?emp_code=${userCode}`,
                         {
                              method: 'GET',
                              headers: {
                                   'Content-Type': 'application/json',
                                   Authorization: `Bearer ${token}`,
                              },
                         }
                    );
                    const result = await response.json();
                    if (result.status && result.data) {
                         setEmployeeDetails(result.data);
                    }
               } catch (error) {
                    console.error('Error fetching employee details:', error);
               } finally {
                    setEmpLoading(false);
               }
          };

          fetchEmployeeDetails();
     }, [baseUrl]);

     // Close popup on outside click
     useEffect(() => {
          const handleClickOutside = (event) => {
               if (
                    popupRef.current &&
                    !popupRef.current.contains(event.target) &&
                    buttonRef.current &&
                    !buttonRef.current.contains(event.target)
               ) {
                    setShowPopup(false);
               }
          };

          document.addEventListener('mousedown', handleClickOutside);
          return () => {
               document.removeEventListener('mousedown', handleClickOutside);
          };
     }, []);

     // Render correct profile component
     const renderProfileComponent = () => {
          if (!employeeDetails) return null;
          if (employeeDetails.emp_type === 'DOCTOR') {
               return <DoctorsProfile data={employeeDetails} />;
          }
          if (employeeDetails.emp_type === 'POOJARI') {
               return <PoojarisProfile data={employeeDetails} />;
          }
          if (employeeDetails.emp_type === 'CONTRACTUAL_EMPLOYEE') {
               return <EmployeesProfile data={employeeDetails} />;
          }
          if (role !== 'EMPLOYEE' || (employeeDetails.is_admin === 'Y' || employeeDetails.emp_type === 'ADMIN')) {
               return <AdminsProfile data={employeeDetails} />;
          }
          return <EmployeesProfile data={employeeDetails} />;
     };


     return (
          <>

               <div style={{ padding: '24px', backgroundColor: '#f7f9fc', minHeight: '100vh' }}>
                    <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                         {empLoading ? (
                              <div style={{ textAlign: 'center', padding: '50px' }}>
                                   <Spinner animation="border" variant="primary" />
                                   <p style={{ marginTop: '16px', color: '#666' }}>Loading employee details...</p>
                              </div>
                         ) : employeeDetails ? (
                              renderProfileComponent()
                         ) : (
                              <div style={{ textAlign: 'center', padding: '50px' }}>
                                   <p style={{ fontSize: '18px', color: '#999' }}>😔 No details found.</p>
                                   <p style={{ fontSize: '14px', color: '#bbb' }}>Please contact HR department.</p>
                              </div>
                         )}
                    </div>
               </div>
          </>
     );
};

export default ProfilePage;